











































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Radiobox extends Vue {
  @Prop({ default: false })
  private readonly active: boolean;

  @Prop({ default: '' })
  private readonly id!: any;

  @Prop({ default: '' })
  private readonly value!: any;

  @Prop({ default: false })
  private readonly isEmpiricusGift!: boolean;

  @Prop({ default: false })
  private readonly isOffer: boolean;

  @Prop({ default: false })
  private readonly bestChoiceFlag: boolean;

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get showRadioHeading(): boolean {
    if (!this.isMobile && this.isEmpiricusGift) {
      return false;
    } else {
      return true;
    }
  }
}
